var map = {
	"./screen1.svg": 326,
	"./screen10.svg": 327,
	"./screen11.svg": 328,
	"./screen12.svg": 329,
	"./screen2.svg": 330,
	"./screen3.svg": 331,
	"./screen4.svg": 332,
	"./screen5.svg": 333,
	"./screen6.svg": 334,
	"./screen7.svg": 335,
	"./screen8.svg": 336,
	"./screen9.svg": 337
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 325;